import { EnvironmentKey } from 'vite-env'

import { Environment } from 'Common/environment/types'

const testBfEnv: Environment = {
    endpoints: {
        assets: 'https://testbf-asset-app.azurewebsites.net',
        calculation: 'https://testbf-calculation-app.azurewebsites.net',
        concept: 'https://testbf-concept-app.azurewebsites.net',
        contact: 'https://testbf-contact-app.azurewebsites.net',
        distribution: 'https://testbf-distribution-app.azurewebsites.net',
        externalApi: 'https://testbf-external-api-app.azurewebsites.net',
        identityserver: 'https://testbf-identity-app.azurewebsites.net/core',
        metadata: 'https://testbf-metadata-app.azurewebsites.net',
        profitability: 'https://testbf-profitability-app.azurewebsites.net',
        royalty: 'https://testbf-royalty-app.azurewebsites.net',
        schilling: 'https://testbf-integration-schilling-app.azurewebsites.net',
        storage: 'https://testbfgeneral.blob.core.windows.net',
        users: 'https://testbf-identity-app.azurewebsites.net/api',
        webhook: 'https://testbf-webhook-app.azurewebsites.net',
        work: 'https://testbf-work-app.azurewebsites.net',
    },
    features: {
        oneflow: true,
        erpIntegration: true,
        newNavigation: true,
        sendOnix: true,
    },
    settings: {
        currency: 'SEK',
        customer: 'testbf',
    },
}

const testWsEnv: Environment = {
    endpoints: {
        assets: 'https://testws-asset-app.azurewebsites.net',
        calculation: 'https://testws-calculation-app.azurewebsites.net',
        concept: 'https://testws-concept-app.azurewebsites.net',
        contact: 'https://testws-contact-app.azurewebsites.net',
        distribution: 'https://testws-distribution-app.azurewebsites.net',
        externalApi: 'https://testws-external-api-app.azurewebsites.net',
        identityserver: 'https://testws-identity-app.azurewebsites.net/core',
        metadata: 'https://testws-metadata-app.azurewebsites.net',
        profitability: 'https://testws-profitability-app.azurewebsites.net',
        royalty: 'https://testws-royalty-app.azurewebsites.net',
        schilling: undefined,
        storage: undefined,
        users: 'https://testws-identity-app.azurewebsites.net/api',
        webhook: 'https://testws-webhook-app.azurewebsites.net',
        work: 'https://testws-work-app.azurewebsites.net',
    },
    features: {
        oneflow: false,
        erpIntegration: true,
        profitability: true,
        royalty: true,
    },
    settings: {
        currency: 'EUR',
        customer: 'testws',
    },
}

const testPeoplesEnv: Environment = {
    endpoints: {
        assets: 'https://testpeoples-asset-app.azurewebsites.net',
        calculation: 'https://testpeoples-calculation-app.azurewebsites.net',
        concept: 'https://testpeoples-concept-app.azurewebsites.net',
        contact: 'https://testpeoples-contact-app.azurewebsites.net',
        distribution: undefined,
        externalApi: 'https://testpeoples-external-api-app.azurewebsites.net',
        identityserver: 'https://testpeoples-identity-app.azurewebsites.net/core',
        metadata: 'https://testpeoples-metadata-app.azurewebsites.net',
        profitability: 'https://testpeoples-profitability-app.azurewebsites.net',
        royalty: 'https://testpeoples-royalty-app.azurewebsites.net',
        schilling: undefined,
        storage: undefined,
        users: 'https://testpeoples-identity-app.azurewebsites.net/api',
        webhook: undefined,
        work: 'https://testpeoples-work-app.azurewebsites.net',
    },
    features: {
        oneflow: false,
        erpIntegration: true,
        newNavigation: true,
        royalty: true,
    },
    settings: {
        currency: 'EUR',
        customer: 'testpeoples',
    },
}

const testNfgEnv: Environment = {
    endpoints: {
        assets: 'https://testnfg-asset-app.azurewebsites.net',
        calculation: 'https://testnfg-calculation-app.azurewebsites.net',
        concept: 'https://testnfg-concept-app.azurewebsites.net',
        contact: 'https://testnfg-contact-app.azurewebsites.net',
        distribution: 'https://testnfg-distribution-app.azurewebsites.net',
        externalApi: 'https://testnfg-external-api-app.azurewebsites.net',
        identityserver: 'https://testnfg-identity-app.azurewebsites.net/core',
        metadata: 'https://testnfg-metadata-app.azurewebsites.net',
        profitability: 'https://testnfg-profitability-app.azurewebsites.net',
        royalty: undefined,
        schilling: undefined,
        storage: undefined,
        users: 'https://testnfg-identity-app.azurewebsites.net/api',
        webhook: 'https://testnfg-webhook-app.azurewebsites.net',
        work: 'https://testnfg-work-app.azurewebsites.net',
    },
    features: {
        oneflow: false,
        erpIntegration: true,
        profitability: true,
        sendOnix: true,
    },
    settings: {
        currency: 'SEK',
        customer: 'testnfg',
    },
}

const testNokEnv: Environment = {
    endpoints: {
        assets: 'https://testnok-asset-app.azurewebsites.net',
        calculation: 'https://testnok-calculation-app.azurewebsites.net',
        concept: 'https://testnok-concept-app.azurewebsites.net',
        contact: 'https://testnok-contact-app.azurewebsites.net',
        distribution: 'https://testnok-distribution-app.azurewebsites.net',
        externalApi: 'https://testnok-external-api-app.azurewebsites.net',
        identityserver: 'https://testnok-identity-app.azurewebsites.net/core',
        metadata: 'https://testnok-metadata-app.azurewebsites.net',
        profitability: 'https://testnok-profitability-app.azurewebsites.net',
        royalty: 'https://testnok-royalty-app.azurewebsites.net',
        schilling: undefined,
        storage: 'https://testnokgeneral.blob.core.windows.net',
        users: 'https://testnok-identity-app.azurewebsites.net/api',
        webhook: 'https://testnok-webhook-app.azurewebsites.net',
        work: 'https://testnok-work-app.azurewebsites.net',
    },
    features: {
        oneflow: false,
        erpIntegration: true,
        newNavigation: true,
        profitability: true,
    },
    settings: {
        currency: 'SEK',
        customer: 'testnok',
    },
}

const devMbEnv: Environment = {
    endpoints: {
        assets: 'https://devmb-asset-app.azurewebsites.net',
        calculation: 'https://devmb-calculation-app.azurewebsites.net',
        concept: 'https://devmb-concept-app.azurewebsites.net',
        contact: 'https://devmb-contact-app.azurewebsites.net',
        distribution: undefined,
        externalApi: 'https://devmb-external-api-app.azurewebsites.net',
        identity: 'https://dev.auth.mockingbird.nu/core',
        metadata: 'https://devmb-metadata-app.azurewebsites.net',
        profitability: 'https://devmb-profitability-app.azurewebsites.net',
        royalty: 'https://devmb-royalty-app.azurewebsites.net',
        schilling: undefined,
        storage: 'https://devmbgeneral.blob.core.windows.net',
        users: 'https://devmb-identity-app.azurewebsites.net/api',
        webhook: 'https://devmb-webhook-app.azurewebsites.net',
        work: 'https://devmb-work-app.azurewebsites.net',
    },
    features: {
        oneflow: false,
        erpIntegration: false,
        newNavigation: true,
        profitability: true,
        royalty: true,
    },
    settings: {
        currency: 'SEK',
        customer: 'devmb',
    },
}

const testBfInfernoEnv: Environment = {
    endpoints: {
        assets: 'https://testbfinferno-asset-app.azurewebsites.net',
        calculation: 'https://testbfinferno-calculation-app.azurewebsites.net',
        concept: 'https://testbfinferno-concept-app.azurewebsites.net',
        contact: 'https://testbfinferno-contact-app.azurewebsites.net',
        distribution: 'https://testbfinferno-distribution-app.azurewebsites.net',
        externalApi: undefined,
        identity: 'https://dev.auth.mockingbird.nu/core',
        metadata: 'https://testbfinferno-metadata-app.azurewebsites.net',
        profitability: undefined,
        royalty: undefined,
        schilling: 'https://testbfinferno-integration-schilling-app.azurewebsites.net',
        storage: 'https://testbfinfernogeneral.blob.core.windows.net',
        users: 'https://testbfinferno-identity-app.azurewebsites.net/api',
        webhook: 'https://testbfinferno-webhook-app.azurewebsites.net',
        work: 'https://testbfinferno-work-app.azurewebsites.net',
    },
    features: {
        oneflow: false,
        erpIntegration: true,
        newNavigation: true,
        profitability: false,
        royalty: false,
    },
    settings: {
        currency: 'SEK',
        customer: 'testbf',
    },
}

export const environments: Record<EnvironmentKey, Environment> = {
    testBf: testBfEnv,
    testWs: testWsEnv,
    testPeoples: testPeoplesEnv,
    testNfg: testNfgEnv,
    testNok: testNokEnv,
    devmb: devMbEnv,
    testBfInferno: testBfInfernoEnv,
}

const currentEnvKey: EnvironmentKey = import.meta.env.VITE_CLIENT_ENV ?? 'test'

export const currentEnvironment = environments[currentEnvKey]
